import React from 'react';
import '../styles/ProjectsSection.scss'; 
import { projectsData } from "../../../Components/Data/ProjectsData";
import ProjectCarousel from './ProjectSection/ProjectCarousel';
import { Link } from 'react-router-dom'; 

const ProjectsTitle = "Receipts.";
const featuredProjects = projectsData.filter((project) => project.featured);

const Project = () => {

    return(
        <div id="projects" className="project-section">
            <div className="project-section-container">
                <h2 className="project-section-title">{ProjectsTitle}</h2>
                <div className="project-section-projects-container">
                    <h3 className="project-section-project-title">PROJECTS</h3>
                    <ProjectCarousel items={featuredProjects} />
                    <div className="all-projects">
                        <Link to="/projects" className="all-projects-link">
                            View All Projects
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Project; 